import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { BrowserRouter, Route } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(<BrowserRouter><Route path='/' render={function(props){return (<App {...props}/>)}} /></BrowserRouter>,document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
